import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, dateUTCShedule, dateUTCLocal, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import Calendar from 'react-calendar';
import Scheduler from '../components/schedule/scheduler';
//import ScheduleAdd from '../components/schedule/add';
//import ScheduleEdit from '../components/schedule/edit';
import OrganiserAdd from '../components/organiser/add';
import OrganiserEdit from '../components/organiser/edit';
import EnImage from '../components/image/image';

import Blocks from '../components/bbcode/blocks';
//import CopyBox from '../components/bbcode/copybox';
//import VideoPlayer from '../components/video/video';
import Genres from '../components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';


//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import './css/stream.css';
//import './css/header.css';
import './css/schedule.css';

//import Bricks 
//import { ReactComponent as Bricks} from './backgrounds/Bricks.svg';

class PortalServiceSchedule extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {

			service: {
				status: false,
				id: parseInt(this.props.service),
				name: '',
			},
			prepare: {
				djs: [],
				genres: [],
				replays: []
			},
			
			date: new Date(),
      
			
			organiser: [],
			schedule: [],
			
			djs: [],

			showModal: false,
			filename_flyer: false,
      
			
			ListenerSchedule: null,
			
			//backgrounds: ['Bricks.svg', 'Prism.svg', 'Bullseye.svg', 'Wavey.svg', 'Radiant.svg', 'Zigzag.svg', 'Triangles.svg', 'Scales.svg', 'Cornered.svg', 'Tortoise.svg', 'Tornado.svg', 'Abstract.svg', 'Randomized.svg']

		};
    this.getSchedule = this.getSchedule.bind(this);
		this.setDate = this.setDate.bind(this);
		this.setMonth = this.setMonth.bind(this);
		this.showModal = this.showModal.bind(this);
		this.organiserAdd = this.organiserAdd.bind(this);
		this.organiserEdit = this.organiserEdit.bind(this);
		this.scheduleZone = this.scheduleZone.bind(this);
		this.clickuploadFlyer = this.clickuploadFlyer.bind(this);
		this.uploadFlyer = this.uploadFlyer.bind(this);
  };

  async componentDidMount() {
		//document.title = "";
		


		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		EventEmitter.emit('/client', y);

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		//await user.setWorker( this.props.service );
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/service/prepare`, params);
		if( x.status === 200 ) this.setState({prepare: x.data});

		await this.getSchedule(server);

		//---- Schedule updates
		const ListenerSchedule = EventEmitter.addListener(`/service/schedule`, async data => {
			if( data.service === this.state.service.id ) await this.getSchedule();
		}); this.setState({ListenerSchedule});

	}

	componentWillUnmount() {
    if( this.state.ListenerSchedule ) this.state.ListenerSchedule.remove();
	}

	async getSchedule(server = null) {

		if( !server ) {
			const value = this.context;
			server = value.worker[this.props.service];
		}

		let d = dateUTCShedule(this.state.date);
		/*let e = dateUTCShedule(this.state.date, -1, -1, 1);
		let f = dateUTCShedule(e);
			f.setMonth(f.getMonth()+1);
			f.setDate(f.getDate()-1);*/

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('schedule', Math.floor(d.getTime()/1000));
		//params.append('start',Math.floor(e.getTime()/1000));
		//params.append('end',Math.floor(f.getTime()/1000));
		const x = await postApi(`${server}/v3/service/schedule`, params);
		if( x.data.organiser ) for( let i in x.data.organiser ) {
			x.data.organiser[i].date = dateUTCLocal(x.data.organiser[i].date);
			x.data.organiser[i].start = dateUTCLocal(x.data.organiser[i].start);
			x.data.organiser[i].end = dateUTCLocal(x.data.organiser[i].end);
		}
		if( x.data.schedule ) for( let i in x.data.schedule ) {
			x.data.schedule[i].date = dateUTCLocal(x.data.schedule[i].date);
			x.data.schedule[i].start = dateUTCLocal(x.data.schedule[i].start);
			x.data.schedule[i].end = dateUTCLocal(x.data.schedule[i].end);
			for( let j in x.data.schedule[i].events ) {
				x.data.schedule[i].events[j].start = dateUTCLocal(x.data.schedule[i].events[j].start);
				x.data.schedule[i].events[j].end = dateUTCLocal(x.data.schedule[i].events[j].end);
			}
		}
		consoleLog(x.data);
		let service = this.state.service;
		if( x.status === 200 ) {
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('Schedule', x.data.servicename);
			}
			this.setState({organiser: [], schedule: [{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: dateUTCLocal("2025-04-01T00:00:00.000Z"),
				description: "",
				end: dateUTCLocal("2025-04-02T04:00:00.000Z"),
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: dateUTCLocal("2025-04-01T22:00:00.000Z"),
				timezone: "America/Detroit",
				zone: 0
			},{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: dateUTCLocal("2025-04-01T00:00:00.000Z"),
				description: "",
				end: dateUTCLocal("2025-04-02T04:00:00.000Z"),
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: dateUTCLocal("2025-04-01T22:00:00.000Z"),
				timezone: "America/Detroit",
				zone: 0
			},{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: dateUTCLocal("2025-04-01T00:00:00.000Z"),
				description: "",
				end: dateUTCLocal("2025-04-02T04:00:00.000Z"),
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: dateUTCLocal("2025-04-01T22:00:00.000Z"),
				timezone: "America/Detroit",
				zone: 0
			},{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: dateUTCLocal("2025-04-01T00:00:00.000Z"),
				description: "",
				end: dateUTCLocal("2025-04-02T04:00:00.000Z"),
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: dateUTCLocal("2025-04-01T22:00:00.000Z"),
				timezone: "America/Detroit",
				zone: 0
			},{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: dateUTCLocal("2025-04-01T00:00:00.000Z"),
				description: "",
				end: dateUTCLocal("2025-04-02T04:00:00.000Z"),
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: dateUTCLocal("2025-04-01T22:00:00.000Z"),
				timezone: "America/Detroit",
				zone: 0
			}]},()=>{
				this.setState({organiser: x.data.organiser, schedule: x.data.schedule});
			});
		}
	}


	setDate(e) {
		this.setState({date: e}, ()=>this.getSchedule());
	}


	setMonth(e) {
		if( e.activeStartDate ) this.setState({date: e.activeStartDate, events: []}, ()=>this.getSchedule());
	}


	timeAgo(time) {
		let date = new Date();
		const _time = Math.floor( Math.abs((Date.now()/1000+date.getTimezoneOffset() * 60) - time) / 60) ;
		let past = time < Math.floor(Date.now()/1000+date.getTimezoneOffset() * 60);
		let _return = '';
		if( _time >= 10 ) _return = Math.floor(_time).toString() + " mins";
		if( _time >= 60 ) _return = Math.floor(_time/60).toString() + " hour" + (Math.floor(_time/60)>1?"s":"");
		if( _time >= 1440 ) _return = Math.floor(_time/1440).toString() + " day" + (Math.floor(_time/1440)>1?"s":"");
		return( <>{!past&&'In '}{_return}{past&&' ago'}</> );
	}


	showModal(event) {
		this.setState({showModal: event});
	}

	organiserAdd(date) {
		this.setState({showModal: {option: 'organiseradd', date, timezone: this.state.organiser[0].timezone}});
	}

	organiserEdit(date) {
		for( let i in this.state.organiser ) {
			if( date.getTime() === this.state.organiser[i].date.getTime() ) {
				if( this.state.organiser[i].dummy === true ) {
					let index = this.state.organiser.findIndex(elem=>elem.id === this.state.organiser[i].id && elem.dummy === false);
					if( index>=0 ) this.setState({showModal: {option: 'organiseredit', id: index}});
					return;
				}
				this.setState({showModal: {option: 'organiseredit', id: parseInt(i)}});
			}
		}
	}

	async scheduleZone(zone) {
		const value = this.context;
		//this.setState({schedule_zone: zone},()=>{
			
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('zone', zone);
			//const value = this.context;
			await putApi(`${value.worker[this.state.service.id]}/v3/service/timezone`, params);
			this.getSchedule();
		//});
	}

	close = (childData) => {
    this.setState({showModal: false}, () => {
			this.getSchedule();
		});
	}


	clickuploadFlyer(date) {
		consoleLog(date);
		this.setState({filename_flyer: date},()=>{
			document.getElementById(`upload_flyer`).click();
		});
	}

	async uploadFlyer(event) {
		const value = this.context;
		const params = new FormData();
		params.append('service', this.state.service.id);
		params.append('files', event.target.files[0]);
		params.append('path', `radio/${this.state.service.id}/flyer/${this.state.filename_flyer}/`);
		//params.append('type', 'flyer');
		//params.append('cover', this.state.filename_flyer);
		consoleLog(event.target.files[0]);
		await putApi(`/v3/upload`, params);

		let params2 = new URLSearchParams();
		params2.append('service', this.state.service.id);
		params2.append('cover', this.state.filename_flyer);
		params2.append('name', event.target.files[0].name.replaceAll(' ',''));

		await postApi(`${value.worker[this.state.service.id]}/v3/service/schedule/flyer`, params2);

		this.setState({filename_flyer: false},()=>{
			this.getSchedule();
		});
	}


	render() {
		const user = this.context;
		//console.log(this.state.date.getTimezoneOffset()*60000);

		const shows = ({ date, view }) => {
			let show = this.state.organiser.find(elem=>elem.date.getTime()===date.getTime());
			if( show ) {
				return (
					<React.Fragment key={show.id}>
						{show.cover && show.cover.length > 0 ?
							<>
								<div className="schedule-event-cover">
									<img src={`https://cloud.ultrastream.io${show.cover}`} alt="Event Flyer" />
								</div>
								{/*<div className="schedule-event-cover d-none d-md-block" style={{ backgroundImage: `url(data:image/svg+xml;base64,${btoa(Bricks)})`, overflow: 'hidden', backgroundSize: 'cover', height: '100%' }} > 
									<Bricks width='100%' height='100%' />
								</div>
								this.state.backgrounds[0]*/}
								{/*<div className="schedule-event">
									<span>{moment(dateLocal(show.date)*1000).format("DD")}</span>
								</div>*/}
							</>
						:
							<div className="schedule-event-blank p-0">
								{/*<div className="d-none d-md-block">*/}
									
										{show.showname?show.showname:moment(show.date).format("dddd")}
										{/*<span>{moment(dateLocal(show.date)*1000).format("DD")}</span>*/}
									
								{/*</div>*/}
							</div>
						}
						<div className="schedule-event">
							<span>{moment(show.date).format("DD")}</span>
						</div>
					</React.Fragment>
				)
			} else {
				if( date.getMonth()===this.state.date.getMonth() )
					return (
						<React.Fragment key={date.getTime()}>
							<div className="schedule-event-blank">
								<span>
									{moment(date).format("dddd")}
								</span>
							</div>
						</React.Fragment>
					)
				else
					return (
						<React.Fragment key={date.getTime()}>
							<div className="schedule-event-blank">
								<span>
									{moment(date).format("DD")}
								</span>
							</div>
						</React.Fragment>
					)
				
			}
		};

		const schedule = this.state.schedule.map((e,i) => {
			//console.log(e.date);
			let _dummy = this.state.organiser.find(elem=>elem.date.getTime() === e.date.getTime());
			
			let dummy = !_dummy?true:_dummy.dummy?_dummy.dummy:false;
			//console.log("dummy:", _dummy, dummy);

			return (
				<React.Fragment key={i}>
					<li>
						<div className="timeline-time text-end"> <span className="time d-inline-block">{moment(e.date).format("DD MMM")}</span> </div>
						<div className="timeline-icon"></div>
						<div className="timeline-body">
							<div className="d-flex align-items-top timeline-main-content mt-0">
								<div className="flex-fill">
									<div className=" align-items-center">
										<div className="mt-sm-0 mt-2">


											<div className="card custom-card">
												<div className="card-header justify-content-between p-0">
													<div className="card-title">{e.showname.length>0?e.showname:moment(e.date).format("dddd, Do MMMM")} {process.env.NODE_ENV==="development"&&<>({e.id})</>}</div>
													<div className="dropdown d-flex">
														{/*user.user.admin&&<>o:{e.oid}&nbsp;e:{e.eid}&nbsp;</>*/}
														<small className="mt-1"><FontAwesomeIcon icon="clock" />&nbsp;{this.timeAgo(Math.floor(e.start.getTime()/1000))}</small>&nbsp;&nbsp;
														{//this.validateSchedule(e.date) ?

														//:
														}
														<Button size="sm" onClick={()=>this.organiserEdit(e.date)} className="py-1 px-2 m-0 mb-2" disabled={dummy}>Edit Event</Button>&nbsp;&nbsp;
														{dummy&&<>
															<Button size="sm" onClick={()=>this.organiserAdd(e.date)} className="py-1 px-2 m-0 mb-2">Create Event</Button>&nbsp;&nbsp;
														</>}
													</div>
												</div>
											</div>

											<Row className="gx-0 pb-3">
												<Col md={2} className="text-center">
													{(this.state.schedule[i].cover && this.state.schedule[i].cover.length > 0 ) ?
														<div className=" mb-2">
															<EnImage src={`https://cloud.ultrastream.io${this.state.schedule[i].cover}?d=${Math.floor(Date.now()/1000)}`} alt="Custom User Flyer" width="100%" className="enimage"  />
														</div>
													:
														<div className=" mb-2">
															<div className="p-0">
																<img src={`https://cloud.ultrastream.io/images/components/flyers.png`} alt="Custom User Flyer" width="100%" className="enimage" />
																{/*<span>
																	{this.state.schedule[i].showname&&this.state.schedule[i].showname.length>0?this.state.schedule[i].showname:moment(this.state.schedule[i].date).format("dddd")}<br />
																	{moment(this.state.schedule[i].date).format("DD MMM")}
																</span>*/}
															</div>
														</div>
													}
													
													<Button size="sm" onClick={()=>this.clickuploadFlyer(Math.floor(dateUTCShedule(this.state.schedule[i].date).getTime()/1000))}>Upload Flyer</Button>
												</Col>
												<Col className="ps-3">
													<h6>Showname: {this.state.schedule[i].showname&&this.state.schedule[i].showname.length>0?this.state.schedule[i].showname:moment(this.state.schedule[i].date).format("dddd")}, {moment(this.state.schedule[i].date).format("DD MMM")}</h6>
													<h6><small><FontAwesomeIcon icon="clock" /> Starts {this.timeAgo(Math.floor(e.start.getTime()/1000))}</small></h6>
													<h6><small>Description:</small></h6>
													{e.description?
														<Blocks blocks={e.description} />
														:
														<>No Description Set</>
													}
													<h6><small>Genres:</small></h6>
													<Genres genres={e?.genres.length>0?e?.genres:['Open House']} />

												</Col>
											</Row>
											
											<Row className="gx-0">
												<Col>
													<Scheduler version="full" service={this.state.service.id} event={{...e}} close={this.close} changeZone={this.scheduleZone} prepare={this.state.prepare} />
												</Col>
											</Row>
										</div>
										<div className=""> <span className="float-end badge bg-light text-muted timeline-badge mt-2  rounded-1"> 07:00 AM </span> </div>
									</div>
								</div>
							</div>
						</div>
					</li>
				</React.Fragment>
			)
		});

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Schedule</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid calendar-mobile">
              <Row>
                <Col xs={12}>
									<div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">{this.state.service.name} Schedule</span>
													<p className="fs-13 text-muted mb-0">Watch the live stream</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										<div className="card-body schedule-calander">
											<Calendar onChange={this.setDate} onActiveStartDateChange={this.setMonth} value={this.state.date} tileContent={shows} maxDetail="month" next2Label='' prev2Label='' />
										</div>
                  </div>
									
								</Col>
								<Col xs={12}>
									<ul className="timeline list-unstyled">
										{schedule}
									</ul>
								</Col>

              </Row>
            </div>
					</div>
				}
				{this.state.showModal!==false && this.state.showModal.option==='organiseradd' && <OrganiserAdd show={this.state.showModal.option==='organiseradd'} close={this.close} date={this.state.showModal.date} timezone={this.state.showModal.timezone} service={this.props.service} /> }
				{this.state.showModal!==false && this.state.showModal.option==='organiseredit' && <OrganiserEdit show={this.state.showModal.option==='organiseredit'} close={this.close} organiser={this.state.organiser[this.state.showModal.id]} service={this.props.service} /> }
				<input id="upload_flyer" type="file" onChange={(e)=>this.uploadFlyer(e,'flyer')} style={{display: 'none'}} />
			</>
		);
	}
}

const Stream = props => {
  const { service } = useParams();
  return <PortalServiceSchedule service={service} {...props} />
}
export default Stream;